"use strict";
exports.__esModule = true;
var baseTranslations = {
    "in %s year": null,
    "in %s years": null,
    "in %s month": null,
    "in %s months": null,
    "in %s day": null,
    "in %s days": null,
    "in %s hour": null,
    "in %s hours": null,
    "in %s minutes": null,
    "in a minute": null,
    "less than a minute ago": null,
    "%s minute ago": null,
    "%s minutes ago": null,
    "%s hour ago": null,
    "%s hours ago": null,
    "%s day ago": null,
    "%s days ago": null,
    "%s month ago": null,
    "%s months ago": null,
    "%s year ago": null,
    "%s years ago": null
};
var translations;
function reset() {
    translations = {};
    for (var _i = 0, _a = Object.keys(baseTranslations); _i < _a.length; _i++) {
        var key = _a[_i];
        translations[key] = baseTranslations[key];
    }
}
exports.reset = reset;
reset();
function set(newTranslations) {
    if (!newTranslations) {
        return;
    }
    for (var _i = 0, _a = Object.keys(newTranslations); _i < _a.length; _i++) {
        var key = _a[_i];
        translations[key] = newTranslations[key];
    }
}
exports.set = set;
function get(phrase) {
    if (!translations[phrase]) {
        return phrase || "";
    }
    return translations[phrase] || "";
}
function translate(phrase, value) {
    var translatedPhrase = get(phrase);
    return translatedPhrase.replace("%s", value);
}
exports.translate = translate;
//# sourceMappingURL=i18n.js.map